import React from 'react';

export const ForgePioHelpjuiceIcon = () => {
	return (
		<svg
			viewBox="0 0 108 108"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			aria-hidden="true"
			focusable="false"
		>
			<g>
				<path
					d="M54.2,38.2c0,0,10.9,14.3,10.9,20.5c0,6.1-5,11.1-11.1,11.1s-11.1-5-11.1-11.1C42.9,52.5,54.2,38.2,54.2,38.2z"
					fill="#5DA3D9"
				/>
				<path
					d="M54,2.7C25.7,2.7,2.7,25.7,2.7,54s23,51.3,51.3,51.3s51.3-23,51.3-51.3S82.3,2.7,54,2.7z M71.3,12.1
						c11.1,4.6,20,13.5,24.6,24.6l-10.4,4.3c-3.5-8.4-10.1-15.1-18.5-18.5L71.3,12.1z M36.7,12.1l4.3,10.4c-8.4,3.5-15.1,10.1-18.5,18.5
						l-10.4-4.3C16.7,25.5,25.5,16.7,36.7,12.1z M36.7,95.9c-11.1-4.6-20-13.5-24.6-24.6l10.4-4.3c3.5,8.4,10.1,15.1,18.5,18.5
						L36.7,95.9z M25.9,54c0-15.5,12.6-28.1,28.1-28.1S82.1,38.5,82.1,54S69.5,82.1,54,82.1S25.9,69.5,25.9,54z M71.3,95.9l-4.3-10.4
						c8.4-3.5,15.1-10.1,18.5-18.5l10.4,4.3C91.3,82.5,82.5,91.3,71.3,95.9z"
					fill="#5DA3D9"
				/>
			</g>
		</svg>
	);
};
